// RUTA: src/components/support/SupportRoute.tsx
//
// Route guard para páginas que solo pueden ver agentes de soporte
// (admin O support). Distinto de AdminRoute (solo admin) y
// CoachRoute (solo coach).
//
// Casos de uso: /admin/soporte (panel de tickets), futuras páginas
// como dashboard de métricas de soporte, asignación de tickets, etc.

import { useUserRole } from '@/hooks/useUserRole';
import { Navigate } from 'react-router-dom';
import { LifeBuoy } from 'lucide-react';

export function SupportRoute({ children }: { children: React.ReactNode }) {
  const { user, canHandleSupport, loading } = useUserRole();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center space-y-4">
          <div className="w-8 h-8 border-4 border-accent/30 border-t-accent rounded-full animate-spin mx-auto" />
          <p className="text-sm text-muted-foreground">Verificando permisos de soporte…</p>
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/auth" replace />;

  if (!canHandleSupport) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center space-y-4 max-w-md mx-auto p-6">
          <div className="w-16 h-16 bg-destructive/10 rounded-full flex items-center justify-center mx-auto">
            <LifeBuoy className="w-8 h-8 text-destructive" />
          </div>
          <h2 className="text-xl font-semibold text-foreground">Acceso Denegado</h2>
          <p className="text-muted-foreground">
            Solo personas con rol de soporte o administrador pueden acceder a este panel.
          </p>
          <button
            onClick={() => window.location.href = '/'}
            className="px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
          >
            Volver al Inicio
          </button>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
